import React, { FC } from 'react'

// Components
import { Button } from '@sketch/components'
import { ModalInjectedProps } from 'containers/ModalManager'
import Modal from 'components/Modal'

interface ShowcaseYourDesignModalProps extends ModalInjectedProps {
  onClose(): void
}

export const ShowcaseYourDesignModal: FC<ShowcaseYourDesignModalProps> = ({
  hideModal,
  onClose,
}) => {
  const handleHideModal = () => {
    onClose()
    hideModal()
  }

  return (
    <Modal.Highlight onCancel={handleHideModal}>
      <Modal.Header>Showcase Your Design Powers</Modal.Header>
      <Modal.Body>
        <p>
          Curate your best work and publish it to your public profile for
          everyone to see. Show off your skills, share templates, or build a
          portfolio — how you use this space is up to you!
        </p>
        <p>
          Your public profile will stay private until you choose to publish it.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary-untinted" onClick={handleHideModal}>
          Customise Public Profile
        </Button>
      </Modal.Footer>
    </Modal.Highlight>
  )
}
